<template>
    <v-container grid-list-md>
        <v-form
            ref="surveyGroupForm"
            v-model="surveyGroupValid"
            lazy-validation
        >
            <v-layout justify-space-between class="my-4">
                <v-flex md10 offset-md1>
                    <v-card class="py-4 px-4">
                        <h3 class="headline mb-4">{{mode ==="create" ? "Créer un groupe de questions" : "Mettre à jour un groupe de questions"}}</h3>
                        <v-layout row class="align-items-center">
                            <v-text-field v-model="name" label="Nom du groupe" required></v-text-field>
                            <SurveyClipboardButton :text-original="nameOriginal"/>
                        </v-layout>
                        <v-layout row class="align-items-center">
                            <v-layout class="flex-column">
                                <v-label >Description</v-label>
                                <wysiwyg class="my-2" v-model="instructions"></wysiwyg>
                            </v-layout>
                            <SurveyClipboardButton :text-original="instructionsOriginal"/>
                        </v-layout>
                        <v-select
                            v-model="rule"
                            label="Règle"
                            :items="getRuleLabels"
                        ></v-select>
                        <v-text-field type="number" v-model="extra" label="Extra"></v-text-field>
                        <v-text-field type="number" v-model="position" label="Position"></v-text-field>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex md10 offset-md1>
                    <h3 class="headline mb-4">Questions</h3>
                    <v-expansion-panel v-model="questionsPanel" expand>
                        <survey-question-form
                            v-for="(question, index) in formGroup.questions"
                            :key="question.id"
                            :index="index"
                            :question="question">
                        </survey-question-form>
                    </v-expansion-panel>
                    <v-btn color="primary" @click="handleAddQuestion">
                        <v-icon>add</v-icon>
                        Ajouter une question
                    </v-btn>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex md10 offset-md1 text-xs-right>
                    <v-btn :disabled="!surveyGroupValid || !isLeastOneQuestionAndAnswer" color="success" @click="validate">
                        Enregistrer
                    </v-btn>

                    <v-btn v-if="mode==='edit' && formGroup.can.delete" color="danger" flat @click="deleteDialog = true">
                        <v-icon>delete</v-icon> Supprimer
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-form>
        <v-dialog v-model="deleteDialog" persistent max-width="480">
            <v-card>
                <v-card-title class="headline">Supprimer le groupe de questions</v-card-title>
                <v-card-text>Voulez-vous vraiment supprimer le groupe de questions ?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="deleteDialog = false">Annuler</v-btn>
                    <v-btn color="primary" text @click="deleteSurveyGroup">Oui, supprimer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>

</template>

<script>
import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'
import SurveyQuestionForm from "./SurveyQuestionForm.vue";
import SurveyClipboardButton from "./components/SurveyClipboardButton.vue";


export default {
    name: "SurveyGroupForm",
    components: {SurveyClipboardButton, SurveyQuestionForm},
    props: {
        mode: {
            type: String,
            default: 'create'
        }
    },
    data() {
        return {
            surveyGroupValid: false,
            deleteDialog: false,
            questionsPanel: [],
        }
    },
    computed: {
        ...mapState('surveys', {
            selectedSurvey: state => state.selected_score,
            formGroup: state => state.form_group,
            language: state => state.currentLanguage,
        }),
        ...mapGetters('surveys', {
            getRuleLabels: 'getRuleLabels',
        }),
        isLeastOneQuestionAndAnswer() {
            return this.formGroup.questions.length > 0 && this.formGroup.questions.every(question => question.answers.length > 0)
        },
        position: {
            get() {
                return this.$store.state.surveys.form_group.position
            },
            set(value) {
                this.setPosition(value)
            }
        },
        name: {
            get() {
                return this.$store.state.surveys.form_group.name
            },
            set(value) {
                this.setName(value)
            }
        },
        nameOriginal() {
            return this.$store.state.surveys.form_group.nameOriginal
        },
        instructions: {
            get() {
                return this.$store.state.surveys.form_group.instructions
            },
            set(value) {
                this.setInstructions(value)
            }
        },
        instructionsOriginal() {
            return this.$store.state.surveys.form_group.instructionsOriginal
        },
        rule: {
            get() {
                return this.$store.state.surveys.form_group.rule
            },
            set(value) {
                this.setRule(value)
            }
        },
        extra: {
            get() {
                return this.$store.state.surveys.form_group.extra
            },
            set(value) {
                this.setExtra(value)
            }
        }
    },
    created() {
        if(this.mode === 'edit') {
            this.setSelectedGroupId(this.$route.params.groupId)
            this.loadScoreGroupForm()
        }
    },
    mounted() {
        if (this.mode === 'create') {
            this.initScoreGroup()
        }
    },
    methods: {
        validate() {
            if (this.$refs.surveyGroupForm.validate()) {
                this.submit()
            }
        },
        submit() {
            if (this.mode === 'create') {
                this.createScoreGroup().then(response => {
                    this.$router.replace({name: 'survey.view', params: {id: this.selectedSurvey.id}})
                }).catch(reason => {
                    //Stay here..
                })
            } else {
                this.updateScoreGroup().then(response => {
                    this.$router.replace({name: 'survey.view', params: {id: this.selectedSurvey.id}})
                }).catch(reason => {
                    //Stay here..
                })
            }
        },
        deleteSurveyGroup() {
            this.deleteDialog = false;
            this.postDeleteScoreGroup().then(response => {
                    this.$router.replace({name: 'survey.view', params: {id: this.selectedSurvey.id}})
                }
            ).catch(reason => {
            })

        },
        handleAddQuestion() {
            this.addNewQuestion()
            this.questionsPanel = this.formGroup.questions.map(() => false)
            this.questionsPanel[this.questionsPanel.length - 1] = true
        },
        ...mapMutations('surveys', {
            setName: 'setFormGroupName',
            setInstructions: 'setFormGroupInstructions',
            setRule: 'setFormGroupRule',
            setExtra: 'setFormGroupExtra',
            setPosition: 'setFormGroupPosition',
            setSelectedGroupId: 'setSelectedGroupId',
            setSelectedScoreId: 'setSelectedScoreId',
            newQuestion: 'newQuestion',
            initScoreGroup: 'initFormGroup',
        }),
        ...mapActions('surveys', ['createScoreGroup', 'addNewQuestion','createScore', 'getScoreInfo', "loadScoreForm", 'updateScoreGroup', 'getScoreInfo', 'loadScoreGroupForm', 'postDeleteScoreGroup']),
    },
    watch: {
        language() {
            if (this.$route.params.groupId) {
                this.loadScoreGroupForm()
            }
        }
    }
}
</script>
